import type { StateStorage } from "zustand/middleware";

const PROBE_KEY = "__lime_persist_probe__";

function isLocalStorageUsable(): boolean {
  try {
    if (localStorage == null) return false;
    localStorage.setItem(PROBE_KEY, PROBE_KEY);
    localStorage.removeItem(PROBE_KEY);
    return true;
  } catch {
    return false;
  }
}

function createMemoryStorage(): StateStorage {
  const store = new Map<string, string>();
  return {
    getItem: (name) => store.get(name) ?? null,
    setItem: (name, value) => {
      store.set(name, value);
    },
    removeItem: (name) => {
      store.delete(name);
    },
  };
}

let memoryStorage: StateStorage | undefined;

// Some Chrome Mobile WebViews and Safari private/sandboxed contexts leave
// `window.localStorage` null (or throw on access), so zustand's default
// `createJSONStorage(() => localStorage)` calls `null.setItem` and throws an
// unhandled TypeError at boot (Sentry LIME-CLIENT-13N / DEV-10683). Falling back
// to a shared in-memory store degrades persistence to session-only instead.
export function getPersistStorage(): StateStorage {
  if (isLocalStorageUsable()) return localStorage;
  memoryStorage ??= createMemoryStorage();
  return memoryStorage;
}
